import { Component, Input, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';

import { NewWorkflowRequestDialogComponent, DialogMode } from '../new-workflow-request-dialog/new-workflow-request-dialog.component';

@Component({
  selector: 'app-new-workflow-request-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatDialogModule, MatDividerModule],
  template: `
    <div class="sidenav-section">
      <h4 class="sidenav-heading">Intake</h4>
      <div class="sidenav-actions">
        <button mat-raised-button color="accent" (click)="openDialog()">
          <mat-icon>add_circle</mat-icon>
          New Workflow Request
        </button>
      </div>
    </div>
    <mat-divider></mat-divider>
  `,
  styles: [`
    :host { display: block; }
    .sidenav-section { padding: 12px 16px 8px; }
    .sidenav-heading { margin: 0 0 8px 0; font-size: 0.75rem; text-transform: uppercase; color: #666; letter-spacing: 0.5px; }
    .sidenav-actions { display: flex; flex-direction: column; }
    .sidenav-actions button { justify-content: flex-start; }
  `]
})
export class NewWorkflowRequestButtonComponent {
  private dialog = inject(MatDialog);

  /**
   * 'intake' (default): the dialog routes the user to the intake form for the
   *   classified document type (contract / BAA / COI).
   * 'workflow': the dialog creates a WorkflowRequest record instead of routing.
   *   Use this from the Workflows list and Workflow detail views.
   */
  @Input() mode: DialogMode = 'intake';

  openDialog(): void {
    this.dialog.open(NewWorkflowRequestDialogComponent, {
      width: '640px',
      maxWidth: '92vw',
      autoFocus: false,
      restoreFocus: false,
      data: { mode: this.mode }
    });
  }
}
